import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { SaleTeamApi } from 'apis/SaleTeamApi';
import { Button, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectData,
  ILazySelectParams,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { useUser } from 'contexts/UserProvider';
import dayjs from 'dayjs';
import { IFilterTeamSaleCb } from 'interfaces/TeamSale/TeamSale';
import Content from 'layouts/Content';
import { useCallback, useEffect, useState } from 'react';

const spanCol = 6;
interface IProps {
  defaultFilter: any;
  isOpen: boolean;
  onSearch: (values: any) => void;
  dataPlant: any;
  dataSearch: any;
  setDataSearch: (value: any) => void;
  typeRevenueOptions: any;
}
const FilterCNPlan = ({
  defaultFilter,
  isOpen,
  dataPlant,
  setDataSearch,
  onSearch,
  typeRevenueOptions,
}: IProps) => {
  const { user } = useUser();
  const [form] = useForm();
  const [teams, setTeams] = useState<any>([]);
  const [teamSaleData, setTeamSaleData] =
    useState<ILazySelectData>(initLazySelectData);

  const onFinish = (values: any) => {
    onSearch(values);
    // setDataSearch(values);
  };

  useEffect(() => {
    form.setFieldsValue({
      ...defaultFilter,
      // ...(defaultFilter?.year && {
      //   year: dayjs(defaultFilter?.year.toString(), 'YYYY'),
      // }),
      chiNhanh: defaultFilter?.plantId,
    });
  }, [defaultFilter, form]);

  const onCancel = () => {
    form.resetFields();
    setDataSearch({ year: dayjs(new Date().getFullYear().toString(), 'YYYY') });
    setDataSearch({});
    form.setFieldsValue({
      ...defaultFilter,
      // ...(defaultFilter?.year && {
      //   year: dayjs(defaultFilter?.year.toString(), 'YYYY'),
      // }),
      chiNhanh: defaultFilter?.plantId,
    });

    // if (!defaultFilter?.plantId) {
    //   setTeams([]);
    // }
  };

  const plants = dataPlant.map((plant: any) => ({
    value: plant.id,
  }));

  const handleChangeBranch = useCallback(
    (value: any) => {
      form.setFieldsValue({ doi: undefined });
      const params = {
        pageSize: 10,
        ...(value && { plantId: value }),
      };

      getTeamSales(params);
    },
    [form],
  );

  useEffect(() => {
    handleChangeBranch(user?.isCN || undefined);
  }, [handleChangeBranch, user?.isCN]);
  const handleDateChange = (date: any, dateString: any) => {
    console.log('date', date);
    const value = date != null ? date : undefined;
    console.log(value);
  };

  const filterOption = useCallback((inputValue: string, option: any) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase());
  }, []);
  const { isPending: getTeamSaleLoading, mutate: getTeamSales } = useMutation({
    mutationFn: (params: IFilterTeamSaleCb) =>
      SaleTeamApi.getAllTeamSaleCb(params),
    onSuccess: (res) => {
      if (res?.data?.getTeamSales) {
        const items = res.data?.getTeamSales?.items ?? [],
          totalItems = res.data?.getTeamSales?.pageInfo?.totalItems ?? 0;

        setTeamSaleData({
          options: items.map((item: any) => ({
            label: `${item.subId} - ${item.name}`,
            value: item.id,
          })),
          totalItems: totalItems,
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const handleTeamSaleScrollChange = (params: ILazySelectParams) => {
    const plant = form.getFieldValue('chiNhanh');
    const teamSaleParams: IFilterTeamSaleCb = {
      ...params,
      plantId: plant || defaultFilter.plant,
    };

    getTeamSales(teamSaleParams);
  };

  return (
    <Content isOpen={isOpen}>
      <Form
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        size="small"
        form={form}
      >
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label={
                <span>
                  Năm
                  <span className="text-red-500"> *</span>
                </span>
              }
              // initialValue={dayjs(new Date().getFullYear().toString(), 'YYYY')}
              name="year"
            >
              <DatePicker
                allowClear={false}
                placeholder="Chọn năm"
                picker="year"
                // defaultValue={dayjs(
                //   new Date().getFullYear().toString(),
                //   'YYYY',
                // )}
                onChange={handleDateChange}
                className="w-full h-[40px]"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Loại doanh thu" name="typeRevenue">
              <SelectForm
                placeholder="Chọn loại doanh thu"
                options={typeRevenueOptions.map((item: any) => ({
                  label: item.name,
                  value: item.id,
                }))}
                filterOption={filterOption}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Chi nhánh" name="chiNhanh">
              <SelectForm
                disabled={user?.isCN}
                placeholder="Chọn chi nhánh"
                options={plants}
                onChange={handleChangeBranch}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Đội bán hàng" name="doi">
              <LazySelectForm
                data={teamSaleData}
                placeholder="Chọn đội"
                loading={getTeamSaleLoading}
                onSelectScrollChange={handleTeamSaleScrollChange}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[12, 12]} justify={'end'}>
          <Col>
            <Button
              title="Hủy"
              customClass={'bg-white !text-main hover:!text-sub'}
              handleOnclick={onCancel}
            />
          </Col>
          <Col>
            <Button fill title="Tìm kiếm" type="submit" />
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default FilterCNPlan;
